<template>
  <nav-bar-chrome
    :start-hidden="hideNavBar" @hideShow="e => $store.commit('navbar/setHideNavBar', e)"
    >
    <template #logo>
      <router-link :to="{name:'home'}">
        <img class="round-logo" src="@/assets/vipro_logo2.png" :title="`${brandFull} v${uiBuildVersion}`"/>
      </router-link>
    </template>
    <template #menu>
      <ul class="menu-items">
        <li><router-link v-if="menuItems.includes('search')"
             @mousedown.native="anim"
            :to="{name: 'search'}"><nobr>
            <font-awesome-icon icon="search" class="mr-2 has-text-danger"/>
            Search
        </nobr></router-link></li>
        <li><router-link v-if="menuItems.includes('messenger')"
             @mousedown.native="anim"
             :to="{name: 'messenger'}"><nobr>
            <font-awesome-icon icon="comment" class="mr-2 has-text-danger"/>
            Messenger
        </nobr></router-link></li>
        <li><router-link v-if="menuItems.includes('policies')"
             @mousedown.native="anim"
             :to="{name: 'policies'}"><nobr>
            <font-awesome-icon icon="atom" class="mr-2 has-text-success"/>
            Policies
        </nobr></router-link></li>
        <li><router-link v-if="menuItems.includes('subjects')"
             @mousedown.native="anim"
             :to="{name: 'subjects'}"><nobr>
            <font-awesome-icon icon="box" class="mr-2 has-text-primary"/>
            Subjects
        </nobr></router-link></li>
        <li><router-link
            @mousedown.native="anim"
            :to="{name: 'user-settings'}"><nobr>
            <font-awesome-icon icon="sliders" class="mr-2 has-text-health"/>
            Settings
        </nobr></router-link></li>
      </ul>
    </template>
    <template #footer>
      <a v-if="showBrandingInFooter === true"
        href="https://vigilantapps.com"
        target="_blank">
        <img src="@/assets/vigilant_logo.png" class="logo"/>
      </a>
      <span v-else class="empty-footer"/>
    </template>
  </nav-bar-chrome>
</template>

<script>
import { mapState } from 'vuex'
import { uiBuildVersion, showBrandingInFooter, brandFull } from '@/services/branding'
import { reactWith, rubberBand, parentTag, forEachChild, clearAnims } from '@/services/animate'

export default {
  computed: {
    ...mapState('navbar', ['hideNavBar']),
    ...mapState('userSettings', ['menuItems']),
    showBrandingInFooter () { return showBrandingInFooter },
    brandFull () { return brandFull },
    uiBuildVersion () { return uiBuildVersion() },
  },
  methods: {
    anim (e) {
      // clear existing
      forEachChild('ul', 'li', clearAnims)(e)
      // apply animation
      reactWith(rubberBand, parentTag('li'))(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.round-logo {
  border-radius: 50%;
  border: 5px solid #00A7BA;
  box-shadow: #000 2px 2px 6px;
}
</style>